import {
  CASCADER_DIVISION,
  CASCADER_DEPARTMENT,
  CASCADER_SECTION,
  CASCADER_PLANT,
  SET_FILTER_OBJECT,
  CASCADER_OPTION,
} from './actions'

const initialState = {
  division_list: [],
  department_list: [],
  section_list: [],
  plant_list: {
    plant_list: [],
    plant_id: [],
  },
  filterObj: {
    FilterObjDivisionId: '',
    FilterObjDepartmentId: '',
    FilterObjSectionId: '',
  },
  is_loading_division: false,
  is_loading_department: false,
  is_loading_section: false,
  is_loading_plant: false,
  is_loading_handle_filter: false,

  option_list: [],
  is_loading_option: false,

  plant_latest_request_id: 0,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CASCADER_OPTION.REQUEST: {
      return {
        ...state,
        is_loading_option: true,
      }
    }

    case CASCADER_OPTION.SUCCESS: {
      return {
        ...state,
        option_list: action.payload.data || [],
        is_loading_option: false,
      }
    }

    case SET_FILTER_OBJECT: {
      return {
        ...state,
        filterObj: {
          ...state.filterObj,
          ...action.payload,
        },
      }
    }

    case CASCADER_PLANT.REQUEST:
      return {
        ...state,
        plant_latest_request_id: action.payload.requestId,
        is_loading_plant: true,
      }

    case CASCADER_PLANT.SUCCESS:
      if (state.plant_latest_request_id === action.payload.requestId) {
        return {
          ...state,
          plant_list: action.payload.lists || this.state.plant_list,
          is_loading_plant: false,
        }
      }

      return {
        ...state,
      }

    case CASCADER_DIVISION.REQUEST:
      return {
        ...state,
        is_loading_division: true,
      }

    case CASCADER_DIVISION.SUCCESS:
      return {
        ...state,
        division_list: action.payload.lists.division_list || [],
        is_loading_division: false,
      }

    case CASCADER_DEPARTMENT.REQUEST:
      return {
        ...state,
        is_loading_department: true,
      }

    case CASCADER_DEPARTMENT.SUCCESS:
      return {
        ...state,
        department_list: action.payload.lists.department_list || [],
        is_loading_department: false,
      }

    case CASCADER_SECTION.REQUEST:
      return {
        ...state,
        is_loading_section: true,
      }

    case CASCADER_SECTION.SUCCESS:
      return {
        ...state,
        section_list: action.payload.lists.section_list || [],
        is_loading_section: false,
      }

    default:
      return state
  }
}
